import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const CoachNoteIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id="mask0_14890_97232"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="10"
      width="32"
      height="23"
    >
      <path
        d="M13.9324 17.8557C12.5621 21.1553 13.0677 28.0353 13.0677 28.0353C13.0677 28.0353 16.6711 30.3356 19.2527 31.1279C24.7472 32.8141 28.4603 31.9525 33.9423 30.2259C37.8924 28.9818 43.3488 25.3294 43.3488 25.3294V22.7522H41.6737C41.6737 22.7522 41.7866 20.2279 41.2505 18.3924C40.5531 16.0048 39.7501 14.3661 37.808 12.8303C36.6459 11.9114 28.9806 10.0233 23.6338 11.5418C18.7997 12.9147 15.0808 15.0901 13.9324 17.8557Z"
        fill="#E4F56C"
      />
    </mask>
    <g mask="url(#mask0_14890_97232)">
      <path
        d="M13.9324 17.8557C12.5621 21.1553 13.0677 28.0353 13.0677 28.0353C13.0677 28.0353 16.6711 30.3356 19.2527 31.1279C24.7472 32.8141 28.4603 31.9525 33.9423 30.2259C37.8924 28.9818 43.3488 25.3294 43.3488 25.3294V22.7522H41.6737C41.6737 22.7522 41.7866 20.2279 41.2505 18.3924C40.5531 16.0048 39.7501 14.3661 37.808 12.8303C36.6459 11.9114 28.9806 10.0233 23.6338 11.5418C18.7997 12.9147 15.0808 15.0901 13.9324 17.8557Z"
        fill="#4A7875"
      />
      <circle cx="32.2413" cy="26.337" r="12.548" fill="#133C40" />
    </g>
    <mask
      id="mask1_14890_97232"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="6"
      y="27"
      width="29"
      height="12"
    >
      <path
        d="M13.1453 27.8613C13.1453 27.8613 16.3151 28.5367 18.3636 28.8713C24.5436 29.8808 34.355 30.0496 34.355 30.0496L25.081 37.8278C24.3937 38.4042 23.4061 38.4544 22.6393 37.9888C20.5809 36.7387 16.4317 34.4678 13.1453 34.2579C11.214 34.1346 8.77744 34.6717 6.86537 35.223C6.23511 35.4047 5.70685 34.5028 6.19614 34.0659L13.1453 27.8613Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_14890_97232)">
      <path
        d="M13.1453 27.8613C13.1453 27.8613 16.3151 28.5367 18.3636 28.8713C24.5436 29.8808 34.355 30.0496 34.355 30.0496L24.6002 38.231C24.1972 38.5691 23.6203 38.6002 23.1751 38.3199C21.3914 37.1971 16.7494 34.488 13.1453 34.2579C11.214 34.1346 8.77744 34.6717 6.86537 35.223C6.23511 35.4047 5.70685 34.5028 6.19614 34.0659L13.1453 27.8613Z"
        fill="#133C40"
      />
      <circle cx="10.0936" cy="20.3397" r="17.4452" fill="#4A7875" />
    </g>
  </svg>
)
